<template>
    <div>
        <el-alert
            v-if="error"
            style="margin-bottom: 18px;"
            type="error"
        >
            <span v-if="error">: {{ error }}</span>
        </el-alert>
        <el-form
            ref="RegisterForm"
            :model="credentials"
            :rules="validationRules"
            label-position="top"
            status-icon
            novalidate
            label-width="120px"
            class="demo-ruleForm"
        >

            <el-form-item :label="getVerbose('auth_field_email')" prop="email">
                <el-input
                    v-model="credentials.email"
                    type="email"
                    auto-complete="off"
                >
                </el-input>
            </el-form-item>

            <el-form-item :label="getVerbose('auth_field_password')" prop="password1">

                <el-input
                    v-model="credentials.password1"
                    type="password"
                    auto-complete="off"
                >
                </el-input>

            </el-form-item>

            <el-form-item :label="getVerbose('auth_field_password_confirmation')" prop="password2">

                <el-input
                    v-model="credentials.password2"
                    type="password"
                    auto-complete="off"
                >
                </el-input>

            </el-form-item>

            <el-form-item>

                <el-button
                    :loading="connecting"
                    type="primary"
                    @click="submitRegisterForm"
                >
                    {{ getVerbose('auth_register_button') }}
                </el-button>

            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import validator from 'email-validator';
import HttpErrorManager from '../partials/http-error-manager.js';
import {mapGetters} from 'vuex';
export default {
    props:{
        onSuccess: {
            type: Function,
            default(){
                return () => {

                };
            },
            required: false,
        },
    },

    data () {
        return {
            credentials: {
                email: '',
                password1: '',
                password2: '',
            },
            error: '',
            connecting: false,
            validationRules: {
                password1: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error(this.getVerbose('login_please_fill_password')));
                            }else if(value.length < 8){
                                callback(new Error(this.getVerbose('login_PASSWORD_INSECURE')));
                            } else {
                                if (this.credentials.password2 !== '') {
                                    this.$refs.RegisterForm.validateField('password2');
                                }
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                password2: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error(this.getVerbose('login_please_fill_password_again')));
                            } else if (value !== this.credentials.password1) {
                                callback(new Error(this.getVerbose('login_passwords_dont_match')));
                            }else if(value.length < 8){
                                callback(new Error(this.getVerbose('login_PASSWORD_INSECURE')));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                email: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error(this.getVerbose('login_please_fill_email')));
                            } else if(!validator.validate(value)){
                                callback(new Error(this.getVerbose('login_email_incorrect')));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
            }
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'getVerbose',
        ])
    },
    created (){
        this.credentials.email = this.$store.state.api.auth.user.email;
        this.httpErrorManager = new HttpErrorManager();
    },
    methods: {
        submitRegisterForm(event) {
            event.preventDefault();
            this.$refs.RegisterForm.validate((valid) => {
                if (valid) {
                    this.$set(this, 'error', '');
                    this.$set(this, 'connecting', true);

                    this.$store.dispatch('selfRegisterUser', this.credentials).then(() => {
                        this.onSuccess();
                        this.$set(this, 'connecting', false);
                    }).catch((error)=>{
                        this.$set(this, 'connecting', false);
                        this.error = this.httpErrorManager.getMessage(0, error.response.data._errors);
                    });
                } else {
                    return false;
                }
            });
        },
    }
};
</script>

<style module>

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/auth/Register.vue